// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JVMc","toggleWrap":"styles_toggleWrap__2LzcW","content":"styles_content__30j21","selectAreaCode":"styles_selectAreaCode__3F70r"};